import type { RootState } from 'store';

export const getJobListFilters = (state: RootState) => state.job.filter;
export const getJobData = (state: RootState) => state.job.jobData;
export const getOpeningsList = (state: RootState) => state.job.openingsList;
export const getOpeningCandidate = (state: RootState) => state.job.openingCandidate;
export const getJobSteps = (state: RootState) => state.job.steps;
export const getRooms = (state: RootState) => state.job.rooms;
export const getJobCandidates = (state: RootState) => state.job.candidates;
export const getIsCandidateExistsOnJob = (state: RootState) => state.job.isCandidateExistsOnJob;
export const getJobLoader = (state: RootState) => state.job.loader;
export const getJobCandidateDataLoading = (state: RootState) => state.job.candidateDataLoading;
export const getJobApprovers = (state: RootState) => state.job.approversCandidate;
export const getJobApproversLoading = (state: RootState) => state.job.approversCandidateLoading;
export const getJobCVS = (state: RootState) => state.job.cvs;
export const getJobCVSLinks = (state: RootState) => state.job.cvsLinks;
export const getJobUserData = (state: RootState) => state.job.userData;
export const getJobAssignmentId = (state: RootState) => state.job.jobAssignmentId;
export const getJobScorecard = (state: RootState) => state.job.scorecard;
export const getJobInterview = (state: RootState) => state.job.interview;
export const getInterviewFeedbacks = (isTechnical: boolean) => (state: RootState) =>
  isTechnical ? state.job.interviewFeedbacks.technical : state.job.interviewFeedbacks.management;
export const getInterviewFeedbacksLoading = (state: RootState) => state.job.interviewFeedbacksLoading;
export const getJobInterviewLoading = (state: RootState) => state.job.interview_loading;
export const getJobOffering = (state: RootState) => state.job.offeringCandidate;
export const getJobOfferingLoading = (state: RootState) => state.job.offeringCandidateLoading;
export const getJobOfferRecommendation = (state: RootState) => state.job.offerRecommendation;
export const getJobProbationPeriod = (state: RootState) => state.job.probationPeriod;
export const getJobEntryDateLoading = (state: RootState) => state.job.entryDateLoading;
export const getJobActivityListLoading = (state: RootState) => state.job.activityListLoading;
export const getJobTimelineCommentLoading = (state: RootState) => state.job.timelineCommentLoading;
export const getTimelineLoading = (state: RootState) => state.job.timelineLoading;
export const getTodaysInterviews = (state: RootState) => state.job.todaysInterviews;
